// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".default-spinner[data-v-6f37534e]{border:4px solid hsla(0,0%,100%,.1);border-top:4px solid #fff;border-radius:50%;animation:spin-6f37534e 1s linear infinite}@keyframes spin-6f37534e{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
